import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';

import { LoaderEvent } from './../../shared/message.event';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-deactivate-popup',
    templateUrl: './deactivate-popup.component.html',
    styleUrls: ['./deactivate-popup.component.css'],
    providers: [LoaderEvent],
    exportAs: 'activePopupObj'
})
export class DeactivatePopupComponent {

    @ViewChild('childModal') childModal: ModalDirective;
    private stringConstants = CONSTANT_MESSAGES;
    @Input() message = '';
    @Input() popupTitle = '';
    @Input() cancleButton;
    @Output() notify = new EventEmitter<boolean>();
    @Output() deactivateRequest = new EventEmitter<any>();
    @Input() groupList = [];
    private popUpMessage = '';
    private validDays = '';
    private showTheGroup = false;
    private reqObject = {
        groupId: '',
        startDate: new Date(),
        endDate: new Date(),
        reason: '',
        clubName: ''
    };
    private validate = {
        groupId: '',
        startDate: '',
        endDate: '',
        reason: '',
        flag: false,
        dateMatchFlag: false,
        isEndDateAvailable: false
    };
    private startMinDate;
    private endMinDate;
    private confirmTitle = '';
    private confirmMessage = '';
    private startMaxDate;
    private minDate;
    private vendor;
    private timezoneOffset;
    private utilityFunctions = new UtilityFunctions();
    @ViewChild('startDateInput') startDateInput;

    constructor(public router: Router, private loaderEvent: LoaderEvent) {
    }

    public showChildModal(title, message, boolForGroup): void {
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        this.timezoneOffset = this.vendor.timezoneOffset * -1;
        this.popupTitle = title;
        this.message = message;
        this.startMaxDate = '';
        this.resetAll();
        this.showTheGroup = boolForGroup ? boolForGroup : false;
        this.childModal.config.backdrop = false;
        this.childModal.config.keyboard = false;
        this.utilityFunctions.setBackGroundBlack();
        this.childModal.show();
    }

    public hideChildModal(): void {
        this.utilityFunctions.removeBackGroundBlack();
        this.childModal.hide();
    }

    onClickOk(dateMissMatchpopUpObj, confirmPopUpObj) {
        this.reqObject.clubName = this.vendor.clubName;
        if (!this.validateFields()['isEndDateAvailable'] && this.validateFields()['flag']) {
            this.deactivateRequest.emit(this.reqObject);
            this.hideChildModal();
        } else if (this.validateFields()['flag']) {
            this.deactivateRequest.emit(this.reqObject);
            this.hideChildModal();
        } else if (!(this.validateFields()['dateMatchFlag'])) {
            this.popUpMessage = CONSTANT_MESSAGES.DATE_CONFIRMATION;
            dateMissMatchpopUpObj.showChildModal();
            this.hideChildModal();
        }
    }

    calledMainPopup() {
        this.showChildModal(this.popupTitle, this.message, this.showTheGroup);
    }

    confirmAction(event) {
        if (event) {
            this.hideChildModal();
        }
    }

    onClickCancle() {
        this.notify.emit(false);
    }
    /**
     * Validate all fields
     *
     * @returns
     *
     * @memberof DeactivatePopupComponent
     */
    validateFields() {
        try {
            this.validate.flag = true;
            this.validate.dateMatchFlag = true;
            this.validate.isEndDateAvailable = true;
            if (!(this.reqObject.groupId + '').trim() && this.showTheGroup) {
                this.validate.groupId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            }
            if (!(this.reqObject.startDate + '').trim() || this.reqObject.startDate == null) {
                this.validate.startDate = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            }
            if (!(this.reqObject.endDate + '').trim() || this.reqObject.endDate == null) {
                this.validate.isEndDateAvailable = false;
            }
            if (this.validate.isEndDateAvailable && (this.reqObject.startDate + '').trim() && (this.reqObject.endDate + '').trim()) {
                // this.reqObject.endDate.setHours(24, 0, 0, 0);
                if (this.reqObject.startDate.getTime() <= this.reqObject.endDate.getTime()) {
                } else {
                    this.validate.dateMatchFlag = false;
                    this.validate.flag = false;
                }
            }
            if (!(this.reqObject.reason + '').trim()) {
                this.validate.reason = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            }
        } catch (e) {
            console.log(e);
        }
        return this.validate;
    }
    /**
     * Reset all fields
     *
     *
     * @memberof DeactivatePopupComponent
     */
    resetAll() {
        this.reqObject = {
            groupId: '',
            startDate: new Date(),
            endDate: new Date(),
            reason: '',
            clubName: ''
        };
        this.validate = {
            groupId: '',
            startDate: '',
            endDate: '',
            reason: '',
            flag: false,
            dateMatchFlag: false,
            isEndDateAvailable: false
        };
        let timeZoneDate = moment().utcOffset(this.timezoneOffset);
        let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();
        this.reqObject.startDate = (new Date(year, month, date, hour, minutes));
        this.reqObject.endDate = (new Date(year, month, date, hour, minutes));
        this.startMinDate = (new Date(year, month, date, hour, minutes));
        this.endMinDate = (new Date(year, month, date, hour, minutes));
        this.minDate = (new Date(year, month, date, hour, minutes));
    }

    onSelectStartDate() {
        if (this.reqObject.startDate) {
            this.validate.startDate = '';
        } else {
            this.validate.startDate = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        }
    }

    changeEndMinDate(startDate) {
        this.endMinDate = startDate;
    }
    changeStartEndDate(minEndDate) {
        this.startMaxDate = minEndDate;
    }

    validateReason() {
        if (this.reqObject.reason) {
            this.validate.reason = '';
        } else {
            this.validate.reason = 'required';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/deactivate-popup/deactivate-popup.component.ts